module.exports = __webpack_public_path__ + "img/tn-timeline-main-13.0c3ffecc.jpg";